import Vue from 'vue';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

Object.defineProperty(Vue.prototype, '$date', { value: dayjs });
